import {
  setDurableStateValue,
  VALIDATION_ONBOARDING_STORAGE_KEY,
} from '../../../shared/lib/durableState/durableState';

const VALIDATION_ONBOARDING_KEY = VALIDATION_ONBOARDING_STORAGE_KEY;

// Writes go through the durable mirror so the flag survives WebView2 cache
// purges / runtime reinstalls; reads hit localStorage, which bootstrap
// hydration restores from the plugin-mirrored store.
export function hasSeenValidationOnboarding(): boolean {
  try {
    return window.localStorage.getItem(VALIDATION_ONBOARDING_KEY) === '1';
  } catch {
    return false;
  }
}

export function markValidationOnboardingSeen(): void {
  try {
    setDurableStateValue(VALIDATION_ONBOARDING_KEY, '1');
  } catch {
    // Ignore storage failures; onboarding can reopen next visit.
  }
}
